import React from 'react';

const JobCard = ({ title, description, type, location }) => {
  return (
    <div className="border-2 p-6 rounded-lg shadow-lg transform transition duration-500 hover:scale-105">
      <h3 className="text-xl font-bold mb-3">{title}</h3>
      <p className="text-gray-700 mb-3">{description}</p>
      <p className="text-sm text-blue-500 mb-2">{location}</p>
      <p className="text-sm text-green-600">{type}</p>
    </div>
  );
};

export default JobCard;
